module.exports = __webpack_public_path__ + "img/charging-session-infograph-mobile@2x.5f47cc3b.webp";